// Tour step properties:
//   - aboveDrawer: (bool) step targets an element inside a drawer overlay — adjusts z-index accordingly
//   - awaitClick: (string) CSS selector — the tour pauses until the user clicks this element
//   - awaitClickAdvanceDelay: (number) ms to wait after the click before moving to the next step
//   - awaitClickAll: (bool) listen for click on ALL elements matching awaitClick, not just the first
//   - awaitClickDelegate: (bool) use event delegation for awaitClick — resilient to DOM re-renders (e.g. FullCalendar)
//   - awaitClickLast: (bool) target the last matching element and block clicks on all others
//   - blockClickOnlySelectors: (string[]) CSS selectors whose click events are blocked (mousedown allowed for drag-and-drop)
//   - blockClickSelectors: (string[]) CSS selectors whose click AND mousedown events are blocked
//   - blockTarget: (bool|string) true = block clicks on the spotlight target; string = block clicks on that selector
//   - blockTargetException: (string|string[]) inside a blocked target, these selectors stay clickable
//   - blockTargetSiblings: (bool) block all siblings inside the target container, only the awaitClick element stays clickable
//   - congrats: (bool) marks the final congratulatory step (triggers confetti)
//   - content: (string) i18n key for the step body text
//   - hideFinish: (bool) hide the Finish button (used when chaining to another tour)
//   - hidePrev: (bool) hide the Previous button for this step
//   - highlightDays: (bool) add a pulsing highlight to calendar day cells
//   - nextTour: (string) id of the tour to start when this step or tour ends (chaining)
//   - noSpotlight: (bool) disable the spotlight cutout (full overlay, e.g. for congrats)
//   - position: (string) tooltip placement relative to the target — top | bottom | left | right | center
//   - pulse: (bool) show a pulsing animation on the awaitClick element (default: true when awaitClick is set)
//   - raiseAncestors: (bool) raise ancestor stacking contexts so the target escapes its parent z-index
//   - scrollTo: (string) 'top' scrolls the page to top instead of centering the target
//   - spotlightPadding: (number) extra px around the target in the spotlight cutout
//   - target: (string) CSS selector of the element to highlight
//   - title: (string) i18n key for the step title
//   - watchTargets: (string[]) extra CSS selectors included in the spotlight area

export default {
  id: 'settings',
  route: 'settings',
  steps: [
    // --- Step 1: Account tab overview ---
    {
      // target: '.settings .content-section-settings',
      target: '.section.large .settings',
      title: 'tours.settings.steps.account.title',
      content: 'tours.settings.steps.account.content',
      position: 'center',
      spotlightPadding: 40,
      scrollTo: 'top',
      blockTarget: true,
      blockOutsideSpotlight: true
    },
    // --- Step 2: Navigate to Notifications tab ---
    {
      target: '.settings .navigation .notifications',
      title: 'tours.settings.steps.navNotifications.title',
      content: 'tours.settings.steps.navNotifications.content',
      position: 'bottom',
      spotlightPadding: 6,
      awaitClick: '.settings .navigation .notifications',
      awaitClickAdvanceDelay: 400,
      // blockOutsideSpotlight: true
    },
    // --- Step 3: Notifications content overview ---
    {
      target: '.settings .content-section-settings',
      title: 'tours.settings.steps.notifications.title',
      content: 'tours.settings.steps.notifications.content',
      position: 'center',
      spotlightPadding: 8,
      hidePrev: true,
      blockTarget: true,
      // blockOutsideSpotlight: true
    },
    // --- Step 4: Navigate to Users tab ---
    {
      target: '.settings .navigation .users',
      title: 'tours.settings.steps.navUsers.title',
      content: 'tours.settings.steps.navUsers.content',
      position: 'bottom',
      spotlightPadding: 6,
      awaitClick: '.settings .navigation .users',
      awaitClickAdvanceDelay: 400,
      // blockOutsideSpotlight: true
    },
    // --- Step 5: Users management content overview ---
    {
      target: '.settings .content-section-settings',
      title: 'tours.settings.steps.users.title',
      content: 'tours.settings.steps.users.content',
      position: 'center',
      spotlightPadding: 8,
      hidePrev: true,
      blockTarget: true,
      // blockOutsideSpotlight: true
    },
    // --- Step 6: Navigate to Billing tab ---
    {
      target: '.settings .navigation .billing',
      title: 'tours.settings.steps.navBilling.title',
      content: 'tours.settings.steps.navBilling.content',
      position: 'bottom',
      spotlightPadding: 6,
      awaitClick: '.settings .navigation .billing',
      awaitClickAdvanceDelay: 400,
      // blockOutsideSpotlight: true
    },
    // --- Step 7: Billing & subscription content overview ---
    {
      target: '.settings .content-section-settings',
      title: 'tours.settings.steps.billing.title',
      content: 'tours.settings.steps.billing.content',
      position: 'center',
      spotlightPadding: 8,
      hidePrev: true,
      blockTarget: true,
      // blockOutsideSpotlight: true
    },
    // --- Congrats: end of full tour ---
    {
      title: 'tours.settings.steps.congrats.title',
      content: 'tours.settings.steps.congrats.content',
      position: 'center',
      noSpotlight: true,
      congrats: true,
      finalCongrats: true,
      blockOutsideSpotlight: true
    }
  ]
}
